<template>
    <v-dialog
      v-model="dialog"
      width="500"
      scrollable>
      <template v-slot:activator="{ on }">
        <v-btn large class="mt-5" :color="color" dark v-on="on">{{isSend ? 'verstuurd!' :  'versturen per email'}}</v-btn>
      </template>

      <v-card>
        <v-card-title
          class="headline grey lighten-2 justify-space-between pr-1"
          primary-title
        >
          Email sturen
          <v-btn color="primary darken-1" text @click="dialog = false" :disabled="isLoading">Sluiten</v-btn>
        </v-card-title>

        <v-card-text class="pt-5">
          <v-form
          ref="form">
            <v-text-field
              v-model.trim="form.email"
              :rules="emailRules"
              label="Email"
              name="email"
              type="email"
              :disabled="isLoading"
              required></v-text-field>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn
            color="primary"
            text
            @click="validate" 
            :disabled="isLoading">
            Versturen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
const email = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export default {
    name: 'email',
    props: {
        name: {
            type: String,
            required: true
        },
        score: {
            type: Number,
            required: true
        },
        steps: {
            type: Array,
            required: true
        },
        color: {
            default: "dark"
        }
    },
    data () {
      return {
        valid: true,
        dialog: false,
        isLoading: false,
        isSend: false,
        form: {
          email: (this.$store.getters.user != null) ? this.$store.getters.user.email : null,
        },
        emailRules: [
          v => !!v || 'Uw Email is verplicht.',
          v => email.test(v) || "Ongeldig email adres."
          //v => (v && v.length <= 10) || 'Name must be less than 10 characters',
        ],
      }
    },
    methods: {
      validate() {
        if (this.$refs.form.validate()) {          
            let q = {
                name: this.name,
                score: this.score,
                json: JSON.stringify(this.steps)
            };
            this.isLoading = true;
            this.$http.post("api/Questionaire/Mail", { questionare: q, email: this.form.email }).then((res) => {
                this.dialog = false;
                this.isSend = true;
            }).finally(() => {
                this.isLoading = false;
            })
        }
      }
    }
  }
</script>